import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from '../index.css';
import Avatar from '../Avatar';
import Like from '../Like';
import Content from '../Content';
import Footer from '../Footer';

const SubComment = ({ content, position, allowComment }) => {
    const {
        id,
        comment,
        commentUserImgSrc: avatar,
        commentUserName: userName,
        userLikeStatus,
        likeCount,
        subjectId,
        replyUser,
        checkStatus,
        updateTime,
        createTime,
        hideExtra,
        commentUserId,
        rootId,
    } = content;

    return (
        <div className={styles.wrap}>
            <div className={styles.comment}>
                <div className={styles.commentLeft}>
                    <Avatar link={avatar} size={'small'} />
                </div>
                <div className={styles.commentRight}>
                    <div className={styles.header}>
                        <div className={styles.userName}>{userName}</div>
                        <Like
                            like={userLikeStatus === 1}
                            count={likeCount}
                            subjectId={subjectId}
                            commentId={id}
                            position={position}
                        />
                    </div>
                    <Content content={{ comment, replyUser, checkStatus }} />
                    <Footer
                        content={{
                            updateTime,
                            createTime,
                            hideExtra,
                            commentUserId,
                            subjectId,
                            commentId: id,
                            comment,
                            userName,
                            rootId,
                            position,
                            allowComment,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

SubComment.propTypes = {
    content: PropTypes.object,
    position: PropTypes.string,
    allowComment: PropTypes.bool,
};

export default errorBoundary(SubComment);
